import { createSlice } from "@reduxjs/toolkit";

// Normalizes an id candidate for identity comparisons across this slice:
// "12" and 12 must be treated as the same tank. Anything that isn't a real
// number (undefined/null/""/non-numeric) normalizes to null, which never
// matches - update()/removeT() treat that as a no-op instead of throwing,
// since a stale/partial cache-invalidation payload for an entity that isn't
// cached yet (or a caller with no try/catch) must never crash the app.
const toId = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const n = Number(value);
    return Number.isNaN(n) ? null : n;
};

export const tanksSlice = createSlice({
    name: 'tanks',
    initialState: [],
    reducers: {
        emptyTanks: state => {
            return []
        },
        setTanks: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        add: (state, action) => {
            return [...state, ...action.payload]
            // return []
        },
        // Upsert: merges into the existing tank (payload wins over stale
        // fields, existing fields not present in payload are preserved), or
        // inserts it if it isn't cached yet. Never throws.
        update: (state, action) => {
            const id = toId(action?.payload?.id);
            if (id === null) return state;

            const foundedIndex = state.findIndex((tank) => toId(tank.id) === id);
            if (foundedIndex !== -1) {
                state[foundedIndex] = { ...state[foundedIndex], ...action.payload };
            } else {
                state.push(action.payload);
            }
        },
        // Idempotent remove: absent entity or invalid id is a no-op, never throws.
        removeT: (state, action) => {
            const id = toId(action?.payload?.id);
            if (id === null) return state;
            return state.filter((tank) => toId(tank.id) !== id);
        }
    }
});

export const {
    setTanks, 
    emptyTanks,
    update,
    removeT,
    add
} = tanksSlice.actions;

export default tanksSlice.reducer